import app from "./../../dist/app/bookmarklet.json";

const bkmLink = <HTMLAnchorElement>document.getElementById("bkmLink");
bkmLink.href = app.bookmarklet;
bkmLink.addEventListener("click", (e) => e.preventDefault());

const bkmTry = <HTMLAnchorElement>document.getElementById("bkmTry");
bkmTry.addEventListener("click", () => window.eval(app.bookmarklet));
